var map = {
	"./Fleet-Commander-Game.png": 83,
	"./colt-express.jpg": 84,
	"./cyclades.jpg": 85,
	"./innovation.jpg": 86,
	"./lords-of-xidit.jpg": 87,
	"./serenissima.jpg": 88,
	"./tikal.jpg": 89,
	"./yedo.jpg": 90
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82;